'use strict';

var Marionette = require('backbone.marionette');

var View = require('./service-list-item').default;

export default Marionette.CollectionView.extend({

  tagName: 'ul',
  className: 'service-list',
  childView: View,

  initialize: function(options) {
    this.appointment = options.appointment;
  },

  childViewOptions: function() {
    return {
      appointment: this.appointment,
    };
  },

  focus: function() {
    this.$el.find('.service-list-service:first-child input').focus();
  },

  hasChildren: function() {
    return this.children.length > 0;
  },

});
